import { StandaloneLink } from '~/ComponentsTW/wm';
import uploadDevicesExample from '~/files/upload_devices.csv';
import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions } from 'ducks/sites';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { serializeForm } from 'utils/forms/utils';
import validators from 'utils/forms/validators';

const UploadDevices = props => {
    const { siteId } = props;

    const uploading = useSelector(state => state.sites.uploadingDevices);

    const formSchema = [
        {
            accept: 'text/csv\n',
            label: 'File\x2a',
            name: 'file',
            type: 'file',
            validate: [validators.required]
        }
    ];

    const dispatch = useDispatch();
    const onSubmit = values => {
        const data = serializeForm(values, formSchema);
        dispatch(actions.uploadDevices(siteId, data.file));
    };

    return (
        <FormViewer label="Upload Devices File">
            <StandaloneLink download="upload_devices.csv" href={uploadDevicesExample} text="Download example file"/>
            <br/>
            <br/>
            <Form
                buttonLabel="Upload"
                formSchema={formSchema}
                isSubmitting={uploading}
                onSubmit={onSubmit}
            />
        </FormViewer>
    );
};

export default UploadDevices;
